import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center">
        <Link to="/" className="mr-8 flex items-center space-x-2">
          <span className="text-xl font-bold gradient-text">LaunchGuide</span>
        </Link>

        {/* Mobile menu button */}
        <button
          type="button"
          id="navbar-menu-button"
          className="inline-flex items-center justify-center rounded-md p-2 text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:hidden ml-auto"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-expanded={isMenuOpen}
          aria-controls="navbar-mobile-panel"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <X className="h-6 w-6" aria-hidden /> : <Menu className="h-6 w-6" aria-hidden />}
        </button>

        {/* Desktop navigation */}
        <div className="hidden md:flex flex-1 items-center justify-between space-x-2 md:justify-end">
          <div className="flex items-center space-x-6">
            <Link to="/about" className="text-foreground/70 transition-colors hover:text-foreground">
              About
            </Link>
            <Link to="/insights" className="text-foreground/70 transition-colors hover:text-foreground">
              Insights
            </Link>
          </div>
          
          <div className="flex items-center space-x-4">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/auth/login">Sign In</Link>
            </Button>
            <Button size="sm" className="relative overflow-hidden group" asChild>
              <Link to="/auth/register">
                Get Started
                <div className="absolute inset-0 w-full h-full bg-white/20 group-hover:bg-white/0 transition-all duration-300 ease-out" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen ? (
        <div
          id="navbar-mobile-panel"
          className="md:hidden border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
          role="dialog"
          aria-modal="true"
          aria-label="Site navigation"
        >
          <div className="container max-h-[min(70vh,calc(100dvh-4rem))] overflow-y-auto py-4 space-y-4">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/about"
                className="text-foreground hover:text-foreground/80 block px-3 py-3 rounded-md text-base font-medium transition-colors min-h-11 flex items-center"
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/insights"
                className="text-foreground hover:text-foreground/80 block px-3 py-3 rounded-md text-base font-medium transition-colors min-h-11 flex items-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Insights
              </Link>
            </div>
            <div className="flex flex-col space-y-3 px-2 pt-4 border-t border-border sm:px-3">
              <Button variant="outline" size="sm" asChild className="justify-center min-h-11 w-full">
                <Link to="/auth/login" onClick={() => setIsMenuOpen(false)}>
                  Sign In
                </Link>
              </Button>
              <Button size="sm" className="justify-center min-h-11 w-full" asChild>
                <Link to="/auth/register" onClick={() => setIsMenuOpen(false)}>
                  Get Started
                </Link>
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </nav>
  );
};

export default Navbar;